import React from "react";
import { Row, Col } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { Form, FormItem, InputItem, TextAreaItem, ButtonItem } from "./Items"; 

const DynamicRecordatoriosList = ({ name, formRef, nombreEstado }) => {
  return (
    <Form.List
      name={[name, "recordatorios"]}
      rules={[
        {
          validator: async (_, recordatorios) => {
            const activado = formRef.current?.getFieldValue([name, nombreEstado || "estado"]);
            
            if (activado && (!recordatorios || recordatorios.length < 1)) {
              return Promise.reject(
                new Error("¡Si activas el recordatorio, debes poner al menos un aviso!")
              );
            }
          },
        },
      ]}
    >
      {(fields, { add, remove }, { errors }) => (
        <>
          {fields.map(({ key, name: fieldName, ...restField }, index) => (
            <div
              key={key}
              style={{
                marginBottom: 20,
                padding: 15,
                border: "1px solid #f0f0f0",
                borderRadius: 5,
              }}
            >
              <Row gutter={16} align="middle">
                <Col span={20}>
                  <FormItem
                    {...restField}
                    name={[fieldName, "dias"]}
                    label={`Aviso ${index + 1} (Días antes)`}
                    margin
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                    rules={[{ required: true, message: "Ingresa los días" }]}
                  >
                    <InputItem type="number" placeholder="Ej. 7" />
                  </FormItem>

                  <FormItem
                    {...restField}
                    name={[fieldName, "mensaje"]}
                    label="Mensaje Personalizado"
                    margin
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                  >
                    <TextAreaItem
                      placeholder="Mensaje opcional..."
                      rows={3}
                      style={{ width: "100%" }}
                    />
                  </FormItem>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <MinusCircleOutlined
                    style={{
                      fontSize: "18px",
                      color: "#ff4d4f",
                      cursor: "pointer",
                    }}
                    onClick={() => remove(fieldName)}
                    title="Eliminar aviso"
                  />
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col span={24}>
              <ButtonItem
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Añadir Recordatorio
              </ButtonItem>
              
              {errors && errors.length > 0 && (
                <div style={{ color: "#ff4d4f", marginTop: "5px", fontSize: "14px" }}>
                  {errors.map((err, index) => (
                    <div key={index}>{err}</div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </>
      )}
    </Form.List>
  );
};

export default DynamicRecordatoriosList;